import { getQuery } from 'utilities/query';

export default class CategoryService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getDefaultQuery() {
    return {
      ...getQuery(),
      orderBy: 'ProductCategoryName',
      direction: 'asc'
    };
  }

  add(category) {
    return this.$http.post('/api/product_category', category);
  }

  delete(id) {
    return this.$http.delete(`/api/product_category/${id}`);
  }

  update(category) {
    return this.$http.put(`/api/product_category/${category.ProductCategoryId}`, category);
  }

  search(query) {
    return this.$http.get('/odata/ProductCategoryOData', {
      params: {
        $select: 'ProductCategoryId, ProductCategoryName, ProductCount, ReportShortName',
        ...query.take && { $top: query.take },
        ...query.page && { $skip: query.calculateSkip() },
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }
}



// WEBPACK FOOTER //
// ./services/category.service.js